<app-logo></app-logo>

<i [ngClass]="icon"></i>

<div class="h1 page-header mt-16" *ngIf="header">{{ header | translate}}</div>

<div class="page-header-info" *ngIf="title">{{ title | translate }}</div>

<div class="page-header-info mt-16" *ngIf="description">{{ description | translate}}</div>
